/* import __COLOCATED_TEMPLATE__ from './toggle-comments-button.hbs'; */
import Component from '@glimmer/component';

export default class ToggleCommentsButton extends Component {}
